import { defineMessages } from 'react-intl';

export const translationBannerScope = 'app.components.translationBanner';

/**
 * The banner is written in the language it suggests (the one the visitor
 * reads best), so every locale names its own language here. The french
 * defaultMessage is never displayed: french is never suggested, it is the
 * language of the unprefixed URL the banner sits on.
 */
export const translationBannerMessages = {
  availableIn: {
    id: `${translationBannerScope}.availableIn`,
    defaultMessage: 'Cette page est disponible en français.',
    en: 'This page is available in English.',
    it: 'Questa pagina è disponibile in italiano.',
    es: 'Esta página está disponible en español.',
    de: 'Diese Seite ist auf Deutsch verfügbar.',
    nl: 'Deze pagina is beschikbaar in het Nederlands.',
  },
  switchTo: {
    id: `${translationBannerScope}.switchTo`,
    defaultMessage: 'Voir en français',
    en: 'Switch to English',
    it: 'Passa all’italiano',
    es: 'Cambiar a español',
    de: 'Zu Deutsch wechseln',
    nl: 'Naar het Nederlands',
  },
  dismiss: {
    id: `${translationBannerScope}.dismiss`,
    defaultMessage: 'Fermer',
    en: 'Close',
    it: 'Chiudi',
    es: 'Cerrar',
    de: 'Schließen',
    nl: 'Sluiten',
  },
};

export default defineMessages(translationBannerMessages);
